import "preact/debug"
import {createHashHistory} from "history"
import {render} from "htm/preact"
import Router from "preact-router"

import {RoundTables} from "../components/Roundtables"
import {ElfsightPopup} from "../utils/fw"
import {handleNewRoute} from "../utils/routing"

import {CometChat} from "./components/CometChat"
import {UserDebug} from "./components/Debug"
import {Navbar} from "./components/Navbar"
import {Room} from "./components/Room"

import "./styles.css"

const rooms = [
	{
		background: "https://assets.swoogo.com/uploads/full/1095851-609193cb93a93.png",
		default: true,
		links: [
			{
				elfsightPopupID: "c3133e47-04b0-48f9-9507-2211a70b2b9f",
				elfsightPopupTrigger: "BT-info-desk-pop-up",
				height: "12%",
				label: "Lobby",
				left: "43%",
				top: "13%",
				width: "14%",
			},
			{
				height: "34.3%",
				href: "/Coffee-Talks",
				isExternal: true,
				label: "Coffee Room",
				left: "76.3%",
				top: "29.7%",
				width: "22.2%",
			},
			{
				height: "34.3%",
				href: "/The-Forum",
				isExternal: true,
				label: "The Forum",
				left: "6.3%",
				top: "33.7%",
				width: "13.2%",
			},
			{
				height: "41.2%",
				href: "/The-Lounge",
				isExternal: true,
				label: "Expert Lounge",
				left: "43.9%",
				top: "30.2%",
				width: "12.6%",
			},
		],
		name: "lobby",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1095850-609193cb8c6e2.png",
		links: [
			{
				elfsightPopupID: "e855aac9-06a2-4b74-abc8-5d65e552e366",
				elfsightPopupTrigger: "BT-corp-new-firms-pop-up",
				height: "14.5%",
				label: "Lobby",
				left: "12.7%",
				top: "17.0%",
				width: "12.2%",
			},
			{
				height: "24.9%",
				label: "Talk to Chris",
				left: "17.5%",
				onClick: () => window.openZoom("chris"),
				top: "54.0%",
				width: "10.0%",
			},
			{
				height: "30.6%",
				label: "Talk to Trish",
				left: "45.3%",
				onClick: () => window.openZoom("trish"),
				top: "61.6%",
				width: "09.4%",
			},
			{
				height: "28.5%",
				label: "Talk to Nat",
				left: "71.7%",
				onClick: () => window.openZoom("nat"),
				top: "53.0%",
				width: "10.2%",
			},
		],
		name: "Coffee Talks",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/990657-6065e8d35f8a7.jpg",
		extras: (
			<>
				<iframe
					style="position: absolute"
					id="screen"
					src="https://www.tkeventsregistration.com/coffee-demo/zoom-test"
				/>
				<iframe
					src="https://assets.swoogo.com/themes/606fce92e6f14/EventusAI+-+Emoji+widget.html"
					id="reactions"
					className="hotspot"
				/>
			</>
		),
		links: [],
		name: "The Forum",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1111510-609a75410c171.jpg",
		extras: <RoundTables />,
		links: [],
		name: "The Lounge",
	},
]

const popups = [
	{
		ID: "c3133e47-04b0-48f9-9507-2211a70b2b9f",
		trigger: "BT-info-desk-pop-up",
	},
	{
		ID: "e855aac9-06a2-4b74-abc8-5d65e552e366",
		trigger: "BT-corp-new-firms-pop-up",
	},
]

render(
	<>
		<Navbar />
		<Router
			history={createHashHistory()}
			onChange={handleNewRoute("platformDemo", "fakeUserID")}
		>
			{rooms.map(Room)}
		</Router>
		{popups.map(ElfsightPopup)}
		<script src="https://apps.elfsight.com/p/platform.js" defer />
		<CometChat />
		<UserDebug />
	</>,
	document.getElementById("content")
)